
/**
 * DeletePatrimonioMaquinaEquipUseCase
 */

import { IDeletePatrimonioMaquinaEquipUseCase } from "../../../presentation/useCases/delete/delete_patrimonio_maquina_equip_use_case";
import { IControlePatrimonioRepository } from "../../repositories/ControledePatrimonio";

export class DeletePatrimonioMaquinaEquipUseCase implements IDeletePatrimonioMaquinaEquipUseCase {
  constructor(private readonly repository: IControlePatrimonioRepository) { }

  async deletePatrimonioMaquinaEquip(idPatrimonioMaquinaEquip: number): Promise<void> {
    await this.repository.deletePatrimonioMaquinaEquip(idPatrimonioMaquinaEquip);
  }
}
